module.exports = __webpack_public_path__ + "img/专利证书03_Smart-EMS高效能源智能决策管控平台v1.0.bb4cb1c7.png";